module.exports = __webpack_public_path__ + "img/af.fa735e43.svg";